var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0258 13.8475L18.595 17.4158L17.4158 18.595L13.8475 15.0258C12.5198 16.0901 10.8683 16.669 9.16667 16.6666C5.02667 16.6666 1.66667 13.3066 1.66667 9.16663C1.66667 5.02663 5.02667 1.66663 9.16667 1.66663C13.3067 1.66663 16.6667 5.02663 16.6667 9.16663C16.6691 10.8683 16.0902 12.5197 15.0258 13.8475ZM13.3542 13.2291C14.4118 12.1415 15.0024 10.6837 15 9.16663C15 5.94329 12.3892 3.33329 9.16667 3.33329C5.94334 3.33329 3.33334 5.94329 3.33334 9.16663C3.33334 12.3891 5.94334 15 9.16667 15C10.6837 15.0023 12.1416 14.4117 13.2292 13.3541L13.3542 13.2291Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.b78d3058486ecaa7c7df2b1086f97f98.svg";
export { ForwardRef as ReactComponent };